var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{staticClass:"j-start align-center"},[_c('b-button',{on:{"click":_vm.limpiar_filtro}},[_vm._v(" Limpiar filtros ")]),_c('h4',{staticClass:"title m-l-15"},[_vm._v(" Total: "+_vm._s(_vm.total)+" ")]),_c('h4',{staticClass:"title m-l-15"},[_vm._v(" | Filtrados: "+_vm._s(_vm.filtered.length)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }